import React from "react";

const Button = ({ onClick, title, className = "bg-red text-white" }) => (
    <p className={`px-md py-sm rounded-lg pointer ${className}`} onClick={onClick}>
        {title}
    </p>
);

export default Button;
